export default __webpack_public_path__ + "static/media/euro.c479d635.png";